import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const RelatorioService = {
    async getMensagensAbonoPagar() {
        const response = await BaseService.fetchResponseFromAPIGet(`relatorio/mensagemferias/abono-pagar`);
        if (response.error) {
            SnackBarModule(response.message, "error");
        }
        return response.content;
    },

    async removerAlerta() {
        const response = await BaseService.fetchResponseFromAPIPost(`relatorio/mensagemferias/lida`);
        if (response.error) {
            SnackBarModule(response.message, "error");
        }
        return response.content;
    },

    async downloadAbonoPagar() {
        const response = await BaseService.downloadItemPost(`relatorios/ferias/parametrizadas/abono-pagar`);
        if (response.error) {
            SnackBarModule(response.message, "error");
        }
        return response.content;
    }

}